/**
 * This file inits the scroll header
 *
 * @package inka
 * @since 1.0.0
 * @author hype.media <web@hype-media.de>
 */

export function scrollHeader() {
    const body = document.body;
    const header = body.querySelector('#masthead');
    const hClasses = header.classList;

    // Body Classes
    const goUp = 'up';
    const goDown = 'down';

    // Variables
    let lastScroll = 0;
    let start = 250;

    //=== === === HEADER DEFAULT === === === //
    if ( hClasses.contains('fixed-top') || hClasses.contains('sticky-top') ) {
        window.addEventListener('scroll', () => {
            const currentScroll = window.pageYOffset;

            if (currentScroll > start) {
                if (currentScroll === 0) {
                    body.classList.remove(goUp);
                    return;
                }

                if (currentScroll > lastScroll && !body.classList.contains(goDown)) {
                    body.classList.remove(goUp);
                    body.classList.add(goDown);
                } else if (currentScroll < lastScroll && body.classList.contains(goDown)) {
                    body.classList.remove(goDown);
                    body.classList.add(goUp);
                }
                lastScroll = currentScroll;
            } else {
                body.classList.remove(goUp);
            }
        });
    }
}


export function scrollSection() {
    // Check if an element with the class '.slide-up' exists
    const hasSlideUpElement = document.querySelector('.slide-up');

    if (hasSlideUpElement) {
        // Select your scroll-up element
        const scrollUpElement = document.querySelector('.slide-up');

        // Define the scroll trigger point
        const scrollTriggerPoint = 50; // Adjust this value as needed

        // Add an event listener for scrolling
        window.addEventListener('scroll', () => {
            const scrollY = window.scrollY;

            // Check if the user has scrolled past the trigger point
            if (scrollY > scrollTriggerPoint) {
                // Add a class to move the element up
                scrollUpElement.classList.add('slide-element');
            } else {
                // Remove the class if the user scrolls back up
                scrollUpElement.classList.remove('slide-element');
            }
        });
    }
}